import React from 'react';
import './toogles.css';
import { useVideoRoomI18nProvider, VideoRoomI18nMessage } from '../../../components/VideoRoomI18n';
import useLocalAudioToggle from '../../../hooks/useLocalAudioToggle';
import useVideoContext from "../../../hooks/useVideoContext";
import Fab from '../Fab';
import Tooltip from '../Tooltip';
import MicOff from '../../../icons/MicOff';
export default function ToggleAudioButton(_ref) {
  var disabled = _ref.disabled;

  var _useLocalAudioToggle = useLocalAudioToggle(),
      isAudioEnabled = _useLocalAudioToggle[0],
      toggleAudioEnabled = _useLocalAudioToggle[1];

  var _useVideoRoomI18nProv = useVideoRoomI18nProvider(),
      format = _useVideoRoomI18nProv.format;

  var _useVideoContext = useVideoContext(),
      themeOptions = _useVideoContext.themeOptions;

  return /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "tooltip-title"
    }, isAudioEnabled ? format(VideoRoomI18nMessage.cta_mute_audio) : format(VideoRoomI18nMessage.cta_unmute_audio))
  }, /*#__PURE__*/React.createElement("span", {
    id: "audio-button"
  }, /*#__PURE__*/React.createElement(Fab, {
    icon: /*#__PURE__*/React.createElement(MicOff, {
      fill: isAudioEnabled ? '' : 'white',
      className: "control-size"
    }),
    theme: themeOptions,
    onClick: toggleAudioEnabled,
    disabled: disabled,
    isIconEnabled: isAudioEnabled,
    size: "small"
  })));
}